import { http } from '@pendo/http';

export function getImportStatus ({ jobId }) {
    return http
        .get(`/api/s/_SID_/vocItem/import/${jobId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function createCSVBucket () {
    return http
        .post('/api/s/_SID_/vocItem/import/csv/new', {}, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function processCSV ({ name }) {
    return http
        .get(`/api/s/_SID_/vocItem/import/csv/parse/${name}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function importFeedbackFromCSV ({
    importId,
    mappings,
    includesHeadersRow,
    filename,
    mutations,
    createMissingVisitorsAndAccounts,
}) {
    return http
        .post(
            '/api/s/_SID_/vocItem/import/csv',
            {
                importPathId: importId,
                mappings,
                includesHeadersRow,
                filename,
                mutations,
                createMissingVisitorsAndAccounts,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function validateCSV ({ importId, mappings, includesHeadersRow, mutations, createMissingVisitorsAndAccounts }) {
    return http
        .post(
            '/api/s/_SID_/vocItem/import/csv/validate',
            {
                importPathId: importId,
                mappings,
                includesHeadersRow,
                mutations,
                createMissingVisitorsAndAccounts,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function importFeedbackFromPollResponses ({ guideId, pollId, timeframe = null }) {
    return http
        .post(
            `/api/s/_SID_/vocItem/import/guide/${guideId}`,
            {
                pollId,
                ...(timeframe?.start && { startTime: timeframe.start }),
                ...(timeframe?.end && { endTime: timeframe.end }),
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function updateAutomaticImportForGuide ({ guideId, autoCreateFeedback }) {
    return http
        .put(
            `/api/s/_SID_/guide/${guideId}/autoCreateFeedback`,
            {
                value: autoCreateFeedback,
            },
            { headers: { 'Content-Type': 'application/json' } },
        )
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
